import { connect } from 'react-redux';
import { CommentableTypes } from '../../../Comment/redux/types';
import { getDeviationById } from '../../../redux/deviations/selectors';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { getCurrentUser } from '../../../publicSession/selectors';
const mapStateToProps = (state, { commentableItemId, commentableType })=>{
    if (commentableType === CommentableTypes.COMMENT_DEVIATION) {
        const deviation = getDeviationById(state, commentableItemId);
        if (deviation) {
            var _deviation_author, _deviation, _deviation1;
            const authorName = (_deviation = deviation) === null || _deviation === void 0 ? void 0 : (_deviation_author = _deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username;
            const { folderId, isPremium, isPaidFolder, subproductId } = normalizePremiumFolderData((_deviation1 = deviation) === null || _deviation1 === void 0 ? void 0 : _deviation1.premiumFolderData);
            if (!isPremium || !deviation.hasPrivateComments) {
                return {
                    commentsDisabledForAllUsers: true
                };
            }
            return {
                commentsDisabledForAllUsers: false,
                folderId,
                subproductId,
                isPaidFolder,
                authorName,
                user: getCurrentUser(state)
            };
        }
    }
    return {
        commentsDisabledForAllUsers: true
    };
};
export default connect(mapStateToProps);
